module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_18.e0400322.mp3";